import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "-my-3.5" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-wrap items-end gap-3"
}
const _hoisted_3 = { class: "-my-3.5" }
const _hoisted_4 = { class: "flex flex-wrap items-end gap-3" }
const _hoisted_5 = { class: "flex flex-wrap items-end gap-3" }
const _hoisted_6 = {
  key: 0,
  class: "rounded-lg bg-emerald-50 px-4 py-3 text-sm text-emerald-800"
}

import { computed } from 'vue'

import InputField from '@/components/neue/InputField.vue'
import AmountField from '@/components/neue/wizard/AmountField.vue'
import HighlightedText from '@/components/neue/wizard/HighlightedText'
import PillRadioGroup from '@/components/neue/wizard/PillRadioGroup.vue'
import ToggleRow from '@/components/neue/wizard/ToggleRow.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { FEE_INTERVAL_TYPES, sectionCopy } from '@/config/membershipTierWizardSteps'
import { recurringFeeExample } from '@/helpers/membershipTierWizardSummary'


export default {
  __name: 'StepFees',
  props: { currency: { type: String, default: 'USD' } },
  setup(__props) {

const props = __props

const wizard = injectWizard()
const fees = computed(() => wizard.data.fees)
const feeExample = computed(() => recurringFeeExample(wizard.data, props.currency))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('signUpFee', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ToggleRow, {
            modelValue: fees.value.signUp.enabled,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((fees.value.signUp.enabled) = $event)),
            title: "Charge a sign-up fee"
          }, null, 8, ["modelValue"])
        ]),
        (fees.value.signUp.enabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(InputField, {
                modelValue: fees.value.signUp.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((fees.value.signUp.name) = $event)),
                name: "Name customers see"
              }, null, 8, ["modelValue"]),
              _createVNode(AmountField, {
                modelValue: fees.value.signUp.amountCents,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((fees.value.signUp.amountCents) = $event)),
                kind: "money",
                name: "Amount"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('recurringFee', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ToggleRow, {
            modelValue: fees.value.recurring.enabled,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((fees.value.recurring.enabled) = $event)),
            title: "Charge a recurring fee"
          }, null, 8, ["modelValue"])
        ]),
        (fees.value.recurring.enabled)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(InputField, {
                  modelValue: fees.value.recurring.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((fees.value.recurring.name) = $event)),
                  name: "Name customers see"
                }, null, 8, ["modelValue"]),
                _createVNode(AmountField, {
                  modelValue: fees.value.recurring.amountCents,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((fees.value.recurring.amountCents) = $event)),
                  kind: "money",
                  name: "Amount"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(AmountField, {
                  modelValue: fees.value.recurring.every,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((fees.value.recurring.every) = $event)),
                  kind: "integer",
                  name: "Charge the fee every",
                  prefix: fees.value.recurring.intervalType === 'dollar_amount' ? '$' : undefined
                }, null, 8, ["modelValue", "prefix"]),
                _createVNode(PillRadioGroup, {
                  modelValue: fees.value.recurring.intervalType,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((fees.value.recurring.intervalType) = $event)),
                  options: _unref(FEE_INTERVAL_TYPES),
                  label: "Charge the fee every"
                }, null, 8, ["modelValue", "options"])
              ]),
              (feeExample.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                    _createVNode(_unref(HighlightedText), { text: feeExample.value }, null, 8, ["text"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

}